<template>
  <div class="event-list">
    <div class="event-title" v-if="activeIndex == 1">
      通知记录
    </div>
    <div class="event-title" v-if="activeIndex == 2">
      紧急通知
    </div>
    {{ activeIndex }}
    <div class="event-list-container" ref="eventListContainer">
      <div class="event-head">
        <div style="display: flex;">
          <el-date-picker style="background: #165D56;border-radius: 4px;border: 1px solid #00A197;height: 32px;"
            v-model="month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div style="display: flex;">
          <div class="options-list">
            <el-input placeholder="搜索申请标题、申请人" v-model="input3" class="input-with-select" prefix-icon="el-icon-search">
              <template slot="append">
                <div class="input-button" @click="onSearch">查询</div>
              </template>
            </el-input>
          </div>
          <div class="download">
            <i class="el-icon-download" style="color:#0EE0D4;"></i>
            <div style="font-size: 13px; color: #0EE0D4;">导出数据</div>
          </div>
        </div>
      </div>
      <div class="event-items">
          <!-- 处理中事件 -->
          <!-- 使用ref替代ID，更安全的获取方式 -->
          <el-table :data="tableData" stripe height="660" :border="false" style="width: 100%">
            <el-table-column prop="noticeTitle" label="通知标题" align="center"></el-table-column>
            <el-table-column prop="noticeTypeName" label="通知类型" width="180" align="center">
              <template slot-scope="scope">
                <div style="display: flex;justify-content: center;">
                  <div style="font-size:12px;color:#fff;padding: 3px 13px;border-radius: 30px;" :style="{backgroundColor:scope.row.noticeTypeColor}">{{ scope.row.noticeTypeName }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
            <el-table-column prop="noticeStatus" label="状态" width="180" align="center">
              <template slot-scope="scope">
                <div style="font-size:12px;color:#0EE0D4;" v-if="scope.row.noticeStatus==1">已发布</div>
                <div style="font-size:12px;color:#FF9500;" v-if="scope.row.noticeStatus==0">草稿</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180">
              <template slot-scope="scope">
                <div style="display: flex;justify-content: center;">
                  <div style="font-size:12px;color:#0EE0D4;" @click="handleInfo(scope.$index, scope.row)" v-if="tableData[scope.$index].noticeStatus==1">查看</div>
                  <div style="font-size:12px;color:#fff;" @click="handleEdit(scope.$index, scope.row)" v-if="tableData[scope.$index].noticeStatus==0">编辑</div>
                  <div style="font-size:12px;color:#FF3A3A;margin-left: 15px;" @click="deleteNotice(scope.$index, scope.row)">删除</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div style="margin-top: 10px;display: flex;justify-content: center;">
        <el-pagination
          background=""
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {Message} from "element-ui";
import {noticeList,deleteNotice} from "@/api/notice";

export default {
  name: 'OrdinaryList',
  props: {
    activeIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      pageNum:1,
      month: '',
      input3: '',
      // 可以在这里添加事件数据
      total:0,
      tableData:[]
    }
  },
  created() {
    //   获取当前月
    const month = new Date().getMonth() + 1
    //   获取当前年
    const year = new Date().getFullYear()

    this.month = `${year}-${month}`;
    
  },
  mounted() {
    
  },
  watch: {
      'month': {
          handler(newVal) {
              if (newVal) {
                  this.pageNum=1;
                  this.tableData=[];
                  this.noticeList();
              }
          },
          immediate: true
      },
      activeIndex: {
        immediate: true,
        handler(newVal, oldVal) {
          console.log('activeindex changed from', oldVal, 'to', newVal);
          if (newVal === 1 || newVal === 2) {
            console.log('Calling noticeList with index:', newVal);
            this.pageNum=1;
            this.tableData=[];
            this.noticeList();
          }
        }
      }
  },
  methods: {
    deleteNotice(index,row){
      deleteNotice({id:row.id}).then(res=>{
        Message.success('删除成功');
        setTimeout(() => {
          if (!this._isDestroyed) this.noticeList();
        }, 1000);
      })
    },
    handleCurrentChange(val) {
      this.pageNum=val;
      this.noticeList();
    },
    onSearch(){
      this.pageNum=1;
      this.tableData=[];
      this.noticeList();
    },
    noticeList(){
      let data={};
      var emergencyStatus = '0';
      if(this.activeIndex == 1) {
        emergencyStatus = '0';
      }else if(this.activeIndex == 2) {
        emergencyStatus = '1';
      }
      data.emergencyStatus= emergencyStatus
      data.pageNum= this.pageNum;
      data.searchTime= this.month;
      data.title=this.input3;
      noticeList(data).then(res=>{
        this.tableData = res.rows;
        this.total = res.total;
      })
    },
    handleEdit(index,row){
      console.log(index,row);
      console.log(row.id);
      this.$emit('onEdit',row.id);
    },
    handleInfo(index,row){
      this.$emit('onDetail',row.id);
    },
    onUnder() {
      Message.info('功能开发中，敬请期待！');
    },
    handleTypeClick(type) {
      this.activeType = type;
    },
    // 加载事件数据的方法
    loadEvents(estateId) {
      let data={};
      data.estateId=estateId
      getEstateAllComplaint(data).then(res=>{
        this.events = res.rows;
      })
    }
  }
}
</script>

<style scoped>
.event-list {
  display: flex;
  flex-direction: column;
  width: 1530px;
  height: 880px;
  background-color: rgba(51,142,134,0.16);
  border-radius: 4px;
  overflow: hidden;
}

.event-title {
  width: 320px;
  padding: 10px 20px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  background-image: linear-gradient(135deg, #016565, #0a2442);
  clip-path: polygon(0 0, 70% 0%, 100% 100%, 0 100%);
  flex-shrink: 0;
}

.event-list-container {
  margin: 15px;
  background-color: rgb(4, 13, 16, 0.8);
  color: #fff;
  padding: 20px;
  width: 1500px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
}

.event-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.download {
  display: flex;
  align-items: center;
  border: 1px solid #0EE0D4;
  background-color: rgba(77, 241, 227, 0.3);
  height: 32px;
  margin-left: 10px;
  padding: 0 10px;
  border-radius: 5px;
}

/* 表格样式 */
:deep(.el-table) {
  background-color: transparent;
  color: #fff;
}

:deep(.el-table th) {
  background: rgba(18,59,55,0.3);
  color: #fff;
}

:deep(.el-table tr) {
  background-color: transparent;
}

:deep(.el-table td) {
  border-right: none !important;
}

:deep(.el-table--enable-row-hover .el-table__body tr:hover>td) {
  background: rgba(18,59,55,0.3);
}

/* 斑马纹表格样式 */
:deep(.el-table--striped .el-table__body tr.el-table__row--striped td) {
  background: rgba(18, 59, 55, 0.3) !important;  /* 斑马纹背景色 */
}

:deep(.el-table--striped .el-table__body tr.el-table__row--striped:hover td) {
  background: rgba(18, 59, 55, 0.5) !important;  /* 斑马纹悬停背景色 */
}

/* 普通行样式 */
:deep(.el-table__body tr) {
  background: transparent !important;  /* 普通行背景色 */
}

:deep(.el-table__body tr:hover td) {
  background: rgba(18, 59, 55, 0.5) !important;  /* 悬停背景色 */
}

/* 表头样式 */
:deep(.el-table th) {
  background: rgba(18, 59, 55, 0.5) !important;  /* 表头背景色 */
  color: #fff !important;
  border: none !important;
}

/* 单元格样式 */
:deep(.el-table td) {
  border: none !important;
  color: #fff !important;
}

:deep(.el-date-editor.el-input, .el-date-editor.el-input__inner) {
  width: 120px;
}

/* 修改日期选择器占位符颜色 */
:deep(.el-date-editor .el-input__inner::placeholder) {
  color: #0EE0D4 !important;  /* 设置占位符颜色为青色 */
  opacity: 1;  /* 确保颜色完全显示 */
}

.input-with-select {
  border: 1px solid #0EE0D4;
  background-color: rgba(77, 241, 227, 0.3);
  margin-bottom: 10px;
  border-radius: 4px;
  font-size: 13px;
}

.input-with-select ::v-deep .el-input__inner::placeholder {
  color: rgba(14, 224, 212, 1); /* 输入文字颜色 */
}

/* 修改 append 区域样式 */
.input-with-select :deep(.el-input-group__append) {
  background-color: rgba(255, 255, 255, 0) !important;
  border: none;
  color: #0EE0D4;
}

/* 修改搜索图标的颜色 */
.input-with-select :deep(.el-input__prefix) .el-input__icon {
  color: #0EE0D4; /* 设置你需要的颜色值 */
}

.input-with-select :deep(.el-icon-search) {
  color: #0EE0D4 !important;
  font-size: 16px; /* 调整图标大小 */
}

.input-button {
  padding: 3px 13px;
  border-radius: 30px;
  color: #fff;
  background: linear-gradient( 360deg, #00E0DC 0%, rgba(0,224,220,0.46) 30%, rgba(0,224,220,0.07) 64%, #00E0DC 100%);
}

/* 分页按钮样式 */
:deep(.el-pagination.is-background .btn-prev),
:deep(.el-pagination.is-background .btn-next) {
  background: linear-gradient( 360deg, #097073 0%, rgba(0,61,59,0.5) 100%) !important;
  color: #0EE0D4 !important;
}

/* 分页数字按钮样式 */
:deep(.el-pager li) {
  background: linear-gradient( 360deg, #097073 0%, rgba(0,61,59,0.5) 100%) !important;
  color: #418484 !important;
  margin: 0 5px;
  border-radius: 4px;
}

/* 当前页样式 */
:deep(.el-pager li.active) {
  background: linear-gradient( 360deg, #00B6B3 0%, rgba(0,121,109,0.49) 100%) !important;
  color: #0EE0D4 !important;
  border: none !important;
}

/* 分页跳转输入框样式 */
:deep(.el-pagination .el-pagination__jump) {
  color: #0EE0D4 !important;
  margin-left: 10px;
}

:deep(.el-pagination__editor.el-input .el-input__inner) {
  background: linear-gradient(360deg, #097073 0%, rgba(0, 61, 59, 0.5) 100%) !important;
  border: 1px solid #0EE0D4 !important;
  border-radius: 4px !important;
  color: #0EE0D4 !important;
  height: 28px;
  line-height: 28px;
  text-align: center;
}

/* 分页跳转文字样式 */
:deep(.el-pagination__jump .el-pagination__jump-text) {
  color: #0EE0D4;
  margin-right: 5px;
}
</style>
